import { combineReducers } from 'redux';
import { reduxKey } from './constants';
import { AccountSettingsPage } from './types';
import personalInformationReducer from './widgets/personalInformation/reducer';
import usernameRenameReducer from './widgets/usernameRename/reducer';
import browseSettingsReducer from './widgets/browseSettings/reducer';
import aiContentReducer from './widgets/aiContent/reducer';
import mutedTagsReducer from './widgets/mutedTags/reducer';
import browsingModeReducer from './widgets/browsingMode/reducer';
import changePasswordReducer from './widgets/changePassword/reducer';
import blockedUsernamesReducer from './widgets/blockedUsernames/reducer';
import notificationsReducer from './widgets/notifications/reducer';
import promotionalBannersReducer from './widgets/promotionalBanners/reducer';
import twoFactorAuthReducer from './widgets/twoFactorAuth/reducer';
import authorizedAppsReducer from './widgets/authorizedApps/reducer';
import deactivateAccountReducer from './widgets/deactivateAccount/reducer';
import sessionsReducer from './widgets/sessions/reducer';
import changeEmailReducer from './widgets/changeEmail/reducer';
import gdprReducer from './widgets/gdpr/reducer';
import { deactivationStatusReducer } from './reducer';

const buildFakeReducer =
  defaultValue =>
  (state = defaultValue, _action) =>
    state;

const rootReducer = combineReducers({
  currentPage: buildFakeReducer(AccountSettingsPage.MyAccount),
  widgets: combineReducers({
    personalInformationWidget: personalInformationReducer,
    usernameRenameWidget: usernameRenameReducer,
    browseSettingsWidget: browseSettingsReducer,
    aiContentWidget: aiContentReducer,
    mutedTagsWidget: mutedTagsReducer,
    browsingModeWidget: browsingModeReducer,
    changePasswordWidget: changePasswordReducer,
    blockedUsernamesWidget: blockedUsernamesReducer,
    notificationsWidget: notificationsReducer,
    promotionalBannersWidget: promotionalBannersReducer,
    twoFactorAuthWidget: twoFactorAuthReducer,
    authorizedAppsWidget: authorizedAppsReducer,
    deactivateAccountWidget: deactivateAccountReducer,
    sessionsWidget: sessionsReducer,
    changeEmailWidget: changeEmailReducer,
    gdprWidget: gdprReducer,
  }),
  deactivationStatus: deactivationStatusReducer,
  isSocialLogin: buildFakeReducer(false),
});

export default {
  [reduxKey]: rootReducer,
};
